import { defineNuxtPlugin, useRoute } from '#imports';
import { useAuthStore } from '~/stores/auth';
import { isPublicAuthPath } from '~/utils/auth/publicRoutes';

export default defineNuxtPlugin({
  name: 'auth-bootstrap',
  async setup() {
    const authStore = useAuthStore();
    const route = useRoute();

    if (!isPublicAuthPath(route.path) && authStore.token) {
      await authStore.fetchUser();
    }
  },
});
